import { CIcon } from '~/icons/types'

export const ciListOrdered: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M10 7.5h11a1.5 1.5 0 1 0 0-3H10a1.5 1.5 0 1 0 0 3Zm11 3H10a1.5 1.5 0 1 0 0 3h11a1.5 1.5 0 0 0 0-3Zm0 6H10a1.5 1.5 0 1 0 0 3h11a1.5 1.5 0 0 0 0-3ZM6.5 8.592V6A1.5 1.5 0 0 0 5 4.5H4a1.5 1.5 0 0 0-.5 2.915v1.177A1.496 1.496 0 0 0 4 11.5h2a1.495 1.495 0 0 0 .5-2.908Zm-.245 4.122c-.85-.522-1.943-.544-2.926-.054a1.5 1.5 0 0 0 .554 2.838c-.631.63-1.383 1.415-1.383 2.504a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 .816-2.76c.382-.482.684-1.051.684-1.74 0-.95-.465-1.806-1.245-2.288Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'list-ordered',
  type: 'solid'
}
